import React, { useEffect, useState } from "react";
import LayoutNew from "../../components/newComponents/LayoutNew";
import HeaderNew from "../../components/newComponents/HeaderNew";
import MainLayout from "../../components/newComponents/MainLayout";
import NavigationTitle from "../../components/newComponents/NavigationTitle";
import axios from "axios";
import { baseURL, quizURL } from "../../api";
import FeaturedQuizNew from "../../components/newComponents/FeaturedQuizNew";
import classes from "./NoQuestionsFound2.module.css";
import SearchBox from "../../components/newComponents/SearchBox";
import LoadingNew from "../../components/newComponents/LoadingNew";

const NoQuestionsFound2 = ({status}) => {
  const [quizes, setQuizes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDataFromBackend = async () => {
      try {
        setLoading(true);
        const res = await axios.post(`${baseURL}${quizURL}`);
        console.log(res);
        setQuizes(res.data.result);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };
    fetchDataFromBackend();
  }, []);
  return (
    <LayoutNew>
      <HeaderNew status={status}/>
      <SearchBox />
      <MainLayout>
        <NavigationTitle title="" />
        {loading ? (
          <LoadingNew />
        ) : (
          <>
            <div className={classes.container}>
              <h3>No Questions Found! Try again or play another game...</h3>
            </div>
            <FeaturedQuizNew quizes={quizes} />
          </>
        )}
      </MainLayout>
    </LayoutNew>
  );
};

export default NoQuestionsFound2;
